<template>
    <section v-if="dpp.isActive || (dpp.openHouses && dpp.openHouses.length)">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold singleline">{{molang('dpp.propertyOpenHouse.openHouseWithAddress', {streetAddress: dpp.geo?.address})}} </h2>
            <ul class="panel-info">
                <li v-for="openhouse in dpp.openHouses">
                    <a class="link" @click="openHotlead(openhouse, { hotleadType: 'openHouseCalendarHotlead' })" role="button">
                        <i class="icon-calendar-add"></i>
                        {{getOpenDateText(openhouse)}}
                    </a>
                </li>
                <li>
                    <a class="link" @click="openHotlead(null, { hotleadType: 'OpenHouseRequestVirtualTour' })" role="button">
                        <i class="icon-calendar-add"></i>
                        <span v-if="showBuyerAgentCTA()">{{molang('dpp.propertyOpenHouse.scheduleTourBuyerAgent')}}</span>
                        <span v-else>{{molang('dpp.propertyOpenHouse.scheduleTour')}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>
<script src="./property-openhouse.js"></script>

<style lang="scss">
@use "./property-openhouse.scss" as *;
</style>
